// DO NOT EDIT -- generated from fs/services/dx-objects/retentionmetrics.proto

import { OrgToOrgDxObjectCopyResponse } from './copy.proto';
import * as accesscontrol from '../../shared/accesscontrol';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';
import * as segment from '../../api/segment';
import * as visualizationsettings from '../search-settings/visualizationsettings';

export namespace RetentionMetricsPublic {

  export const SetRetentionMetricEndpoint = "/grpc/dx_objects.RetentionMetricsPublic/SetRetentionMetric";
  /** Sets a retention metric */
  export function SetRetentionMetric(sender: (req: SetRetentionMetricRequest, endpoint: string) => Promise<SetRetentionMetricResponse>, req: SetRetentionMetricRequest): { promise: () => Promise<SetRetentionMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetRetentionMetricEndpoint),
      endpoint: SetRetentionMetricEndpoint
    };
  }

  export const MarkRetentionMetricViewedEndpoint = "/grpc/dx_objects.RetentionMetricsPublic/MarkRetentionMetricViewed";
  /** Updates the LastViewed timestamp for a retention metric */
  export function MarkRetentionMetricViewed(sender: (req: MarkRetentionMetricViewedRequest, endpoint: string) => Promise<{}>, req: MarkRetentionMetricViewedRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MarkRetentionMetricViewedEndpoint),
      endpoint: MarkRetentionMetricViewedEndpoint
    };
  }

  export const GetAllRetentionMetricsEndpoint = "/grpc/dx_objects.RetentionMetricsPublic/GetAllRetentionMetrics";
  /** Gets all retention metrics */
  export function GetAllRetentionMetrics(sender: (req: GetAllRetentionMetricsRequest, endpoint: string) => Promise<GetAllRetentionMetricsResponse>, req: GetAllRetentionMetricsRequest): { promise: () => Promise<GetAllRetentionMetricsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllRetentionMetricsEndpoint),
      endpoint: GetAllRetentionMetricsEndpoint
    };
  }

  export const GetRetentionMetricEndpoint = "/grpc/dx_objects.RetentionMetricsPublic/GetRetentionMetric";
  /** Gets a retention metric at the current version */
  export function GetRetentionMetric(sender: (req: GetRetentionMetricRequest, endpoint: string) => Promise<GetRetentionMetricResponse>, req: GetRetentionMetricRequest): { promise: () => Promise<GetRetentionMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetRetentionMetricEndpoint),
      endpoint: GetRetentionMetricEndpoint
    };
  }

  export const StarRetentionMetricEndpoint = "/grpc/dx_objects.RetentionMetricsPublic/StarRetentionMetric";
  /** Stars/unstars a retention metric */
  export function StarRetentionMetric(sender: (req: StarRetentionMetricRequest, endpoint: string) => Promise<{}>, req: StarRetentionMetricRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StarRetentionMetricEndpoint),
      endpoint: StarRetentionMetricEndpoint
    };
  }

  export const ArchiveRetentionMetricEndpoint = "/grpc/dx_objects.RetentionMetricsPublic/ArchiveRetentionMetric";
  /** Archives/unarchives a retention metric */
  export function ArchiveRetentionMetric(sender: (req: ArchiveRetentionMetricRequest, endpoint: string) => Promise<ArchiveRetentionMetricResponse>, req: ArchiveRetentionMetricRequest): { promise: () => Promise<ArchiveRetentionMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveRetentionMetricEndpoint),
      endpoint: ArchiveRetentionMetricEndpoint
    };
  }

  export const BulkArchiveRetentionMetricsEndpoint = "/grpc/dx_objects.RetentionMetricsPublic/BulkArchiveRetentionMetrics";
  export function BulkArchiveRetentionMetrics(sender: (req: BulkArchiveRetentionMetricsRequest, endpoint: string) => Promise<BulkArchiveRetentionMetricsResponse>, req: BulkArchiveRetentionMetricsRequest): { promise: () => Promise<BulkArchiveRetentionMetricsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkArchiveRetentionMetricsEndpoint),
      endpoint: BulkArchiveRetentionMetricsEndpoint
    };
  }

  export const CreateUnnamedRetentionMetricEndpoint = "/grpc/dx_objects.RetentionMetricsPublic/CreateUnnamedRetentionMetric";
  export function CreateUnnamedRetentionMetric(sender: (req: CreateUnnamedRetentionMetricRequest, endpoint: string) => Promise<{}>, req: CreateUnnamedRetentionMetricRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CreateUnnamedRetentionMetricEndpoint),
      endpoint: CreateUnnamedRetentionMetricEndpoint
    };
  }

  export const GetUnnamedRetentionMetricEndpoint = "/grpc/dx_objects.RetentionMetricsPublic/GetUnnamedRetentionMetric";
  export function GetUnnamedRetentionMetric(sender: (req: GetUnnamedRetentionMetricRequest, endpoint: string) => Promise<GetUnnamedRetentionMetricResponse>, req: GetUnnamedRetentionMetricRequest): { promise: () => Promise<GetUnnamedRetentionMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetUnnamedRetentionMetricEndpoint),
      endpoint: GetUnnamedRetentionMetricEndpoint
    };
  }

  export const GetRetentionMetricsAccessEndpoint = "/grpc/dx_objects.RetentionMetricsPublic/GetRetentionMetricsAccess";
  export function GetRetentionMetricsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetRetentionMetricsAccessEndpoint),
      endpoint: GetRetentionMetricsAccessEndpoint
    };
  }
}

/** RetentionMetricsAdmin provides administrative operations for retention metrics that are restricted to FullStory internal users */
export namespace RetentionMetricsAdmin {

  export const CopyRetentionMetricsToOrgEndpoint = "/grpc/dx_objects.RetentionMetricsAdmin/CopyRetentionMetricsToOrg";
  /**
   * CopyRetentionMetricsToOrg copies retention metrics from one org to another. Segments should already exist in the destination org.
   * Only accessible to Fullstory internal users.
   */
  export function CopyRetentionMetricsToOrg(sender: (req: CopyRetentionMetricsToOrgRequest, endpoint: string) => Promise<OrgToOrgDxObjectCopyResponse>, req: CopyRetentionMetricsToOrgRequest): { promise: () => Promise<OrgToOrgDxObjectCopyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CopyRetentionMetricsToOrgEndpoint),
      endpoint: CopyRetentionMetricsToOrgEndpoint
    };
  }
}

/**
 * RetentionMetricDetail is a seat's view of a saved retention metric.
 * It contains the retention metric definition, audit metadata,
 * and seat-level settings such as starred, last viewed timestamp, etc.
 */
export interface RetentionMetricDetail {
  retentionMetric: search_settings.RetentionMetricRecord | null;
  /** Whether the seat in the request has starred the retention metric */
  starred: boolean;
  /** When the seat in the request last viewed the retention metric */
  lastViewed: protobuf.timestamp | null;
}

export interface SetRetentionMetricRequest {
  orgId: string;
  retentionMetric: search_settings.RetentionMetric | null;
  visibility: protoauditstore.Visibility;
}

export interface SetRetentionMetricResponse {
  retentionMetric: RetentionMetricDetail | null;
}

export interface MarkRetentionMetricViewedRequest {
  orgId: string;
  retentionMetricId: string;
}

export interface GetAllRetentionMetricsRequest {
  orgId: string;
  /** If true, archived retention metrics will also be returned. */
  includeArchived: boolean;
}

export interface GetAllRetentionMetricsResponse {
  retentionMetrics: RetentionMetricDetail[];
}

export interface GetRetentionMetricRequest {
  orgId: string;
  retentionMetricId: string;
}

export interface GetRetentionMetricResponse {
  retentionMetric: RetentionMetricDetail | null;
}

export interface StarRetentionMetricRequest {
  orgId: string;
  retentionMetricId: string;
  /** True to star, false to unstar */
  starred: boolean;
}

export interface ArchiveRetentionMetricRequest {
  orgId: string;
  retentionMetricId: string;
  /** True to archive, false to unarchive */
  archived: boolean;
}

export interface ArchiveRetentionMetricResponse {
  retentionMetric: RetentionMetricDetail | null;
}

export interface BulkArchiveRetentionMetricsRequest {
  orgId: string;
  retentionMetrics: ArchiveRetentionMetricRequest[];
}

export interface BulkArchiveRetentionMetricsResponse {
  retentionMetrics: MaybeRetentionMetricDetail[];
}

export interface MaybeRetentionMetricDetail {
  retentionMetricId: string;
  failed?: boolean;
  retentionMetric?: RetentionMetricDetail | null;
}

export namespace MaybeRetentionMetricDetail {
  export enum failed_or_retention_metric {
    failed = 2,
    retentionMetric = 3
  }

  export function failed_or_retention_metric_oneof(m: MaybeRetentionMetricDetail): { opt: failed_or_retention_metric.failed, val: boolean } | { opt: failed_or_retention_metric.retentionMetric, val: RetentionMetricDetail } | null {
    if (m.failed != null) { return { opt: failed_or_retention_metric.failed, val: m.failed } }
    if (m.retentionMetric != null) { return { opt: failed_or_retention_metric.retentionMetric, val: m.retentionMetric } }
    return null;
  }
}

export interface CreateUnnamedRetentionMetricRequest {
  hash: string;
  unnamedRetentionMetric: UnnamedRetentionMetric | null;
}

export interface GetUnnamedRetentionMetricRequest {
  hash: string;
}

export interface GetUnnamedRetentionMetricResponse {
  hash: string;
  retentionMetric: UnnamedRetentionMetric | null;
}

export interface UnnamedRetentionMetric {
  retention: segment.Retention | null;
  id: string;
  name: string;
  description: string;
  retentionSettings: visualizationsettings.RetentionMetricSettings | null;
}

export interface CopyRetentionMetricsToOrgRequest {
  sourceOrgId: string;
  destinationOrgId: string;
  /** Mapping from source segment ID to destination segment ID */
  segmentMappings: { [key: string]: string };
  /** IDs of the retention metrics to copy */
  retentionMetricIds: string[];
}
